import * as R from "react";
import { useLayoutEffect as xe, useEffect as ye } from "react";
import * as ve from "react-dom";
import { P as bt, c as Ae, u as Vt } from "./index-Bud8rdvZ.js";
import { jsx as j } from "react/jsx-runtime";
import { u as be } from "./index-0ioNhtNM.js";
import { a as $t } from "./index-D7uzFyzw.js";
import { u as Re } from "./index-5jQiYUd6.js";
const Oe = ["top", "right", "bottom", "left"], Z = Math.min, W = Math.max, ft = Math.round, lt = Math.floor, V = (t) => ({
  x: t,
  y: t
}), Pe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ce = {
  start: "end",
  end: "start"
};
function yt(t, e, n) {
  return W(t, Z(e, n));
}
function q(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function U(t) {
  return t.split("-")[0];
}
function tt(t) {
  return t.split("-")[1];
}
function Rt(t) {
  return t === "x" ? "y" : "x";
}
function Ot(t) {
  return t === "y" ? "height" : "width";
}
function X(t) {
  return ["top", "bottom"].includes(U(t)) ? "y" : "x";
}
function Pt(t) {
  return Rt(X(t));
}
function Se(t, e, n) {
  n === void 0 && (n = !1);
  const o = tt(t), i = Pt(t), r = Ot(i);
  let s = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (s = ut(s)), [s, ut(s)];
}
function Ee(t) {
  const e = ut(t);
  return [vt(t), e, vt(e)];
}
function vt(t) {
  return t.replace(/start|end/g, (e) => Ce[e]);
}
function De(t, e, n) {
  const o = ["left", "right"], i = ["right", "left"], r = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : o : e ? o : i;
    case "left":
    case "right":
      return e ? r : s;
    default:
      return [];
  }
}
function Le(t, e, n, o) {
  const i = tt(t);
  let r = De(U(t), n === "start", o);
  return i && (r = r.map((s) => s + "-" + i), e && (r = r.concat(r.map(vt)))), r;
}
function ut(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Pe[e]);
}
function Te(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function It(t) {
  return typeof t != "number" ? Te(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function dt(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: i
  } = t;
  return {
    width: o,
    height: i,
    top: n,
    left: e,
    right: e + o,
    bottom: n + i,
    x: e,
    y: n
  };
}
function kt(t, e, n) {
  let {
    reference: o,
    floating: i
  } = t;
  const r = X(e), s = Pt(e), c = Ot(s), l = U(e), a = r === "y", f = o.x + o.width / 2 - i.width / 2, u = o.y + o.height / 2 - i.height / 2, p = o[c] / 2 - i[c] / 2;
  let d;
  switch (l) {
    case "top":
      d = {
        x: f,
        y: o.y - i.height
      };
      break;
    case "bottom":
      d = {
        x: f,
        y: o.y + o.height
      };
      break;
    case "right":
      d = {
        x: o.x + o.width,
        y: u
      };
      break;
    case "left":
      d = {
        x: o.x - i.width,
        y: u
      };
      break;
    default:
      d = {
        x: o.x,
        y: o.y
      };
  }
  switch (tt(e)) {
    case "start":
      d[s] -= p * (n && a ? -1 : 1);
      break;
    case "end":
      d[s] += p * (n && a ? -1 : 1);
      break;
  }
  return d;
}
const Me = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: s
  } = n, c = r.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let a = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: f,
    y: u
  } = kt(a, o, l), p = o, d = {}, m = 0;
  for (let h = 0; h < c.length; h++) {
    const {
      name: w,
      fn: g
    } = c[h], {
      x: v,
      y: A,
      data: x,
      reset: y
    } = await g({
      x: f,
      y: u,
      initialPlacement: o,
      placement: p,
      strategy: i,
      middlewareData: d,
      rects: a,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    f = v ?? f, u = A ?? u, d = {
      ...d,
      [w]: {
        ...d[w],
        ...x
      }
    }, y && m <= 50 && (m++, typeof y == "object" && (y.placement && (p = y.placement), y.rects && (a = y.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : y.rects), {
      x: f,
      y: u
    } = kt(a, p, l)), h = -1);
  }
  return {
    x: f,
    y: u,
    placement: p,
    strategy: i,
    middlewareData: d
  };
};
async function ot(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: i,
    platform: r,
    rects: s,
    elements: c,
    strategy: l
  } = t, {
    boundary: a = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: u = "floating",
    altBoundary: p = !1,
    padding: d = 0
  } = q(e, t), m = It(d), w = c[p ? u === "floating" ? "reference" : "floating" : u], g = dt(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(w))) == null || n ? w : w.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(c.floating)),
    boundary: a,
    rootBoundary: f,
    strategy: l
  })), v = u === "floating" ? {
    x: o,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, A = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(c.floating)), x = await (r.isElement == null ? void 0 : r.isElement(A)) ? await (r.getScale == null ? void 0 : r.getScale(A)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, y = dt(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: v,
    offsetParent: A,
    strategy: l
  }) : v);
  return {
    top: (g.top - y.top + m.top) / x.y,
    bottom: (y.bottom - g.bottom + m.bottom) / x.y,
    left: (g.left - y.left + m.left) / x.x,
    right: (y.right - g.right + m.right) / x.x
  };
}
const $e = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: r,
      platform: s,
      elements: c,
      middlewareData: l
    } = e, {
      element: a,
      padding: f = 0
    } = q(t, e) || {};
    if (a == null)
      return {};
    const u = It(f), p = {
      x: n,
      y: o
    }, d = Pt(i), m = Ot(d), h = await s.getDimensions(a), w = d === "y", g = w ? "top" : "left", v = w ? "bottom" : "right", A = w ? "clientHeight" : "clientWidth", x = r.reference[m] + r.reference[d] - p[d] - r.floating[m], y = p[d] - r.reference[d], P = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a));
    let O = P ? P[A] : 0;
    (!O || !await (s.isElement == null ? void 0 : s.isElement(P))) && (O = c.floating[A] || r.floating[m]);
    const D = x / 2 - y / 2, H = O / 2 - h[m] / 2 - 1, S = Z(u[g], H), F = Z(u[v], H), N = S, C = O - h[m] - F, k = O / 2 - h[m] / 2 + D, L = yt(N, k, C), T = !l.arrow && tt(i) != null && k !== L && r.reference[m] / 2 - (k < N ? S : F) - h[m] / 2 < 0, M = T ? k < N ? k - N : k - C : 0;
    return {
      [d]: p[d] + M,
      data: {
        [d]: L,
        centerOffset: k - L - M,
        ...T && {
          alignmentOffset: M
        }
      },
      reset: T
    };
  }
}), ke = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: i,
        middlewareData: r,
        rects: s,
        initialPlacement: c,
        platform: l,
        elements: a
      } = e, {
        mainAxis: f = !0,
        crossAxis: u = !0,
        fallbackPlacements: p,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...w
      } = q(t, e);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const g = U(i), v = X(c), A = U(c) === c, x = await (l.isRTL == null ? void 0 : l.isRTL(a.floating)), y = p || (A || !h ? [ut(c)] : Ee(c)), P = m !== "none";
      !p && P && y.push(...Le(c, h, m, x));
      const O = [c, ...y], D = await ot(e, w), H = [];
      let S = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (f && H.push(D[g]), u) {
        const L = Se(i, s, x);
        H.push(D[L[0]], D[L[1]]);
      }
      if (S = [...S, {
        placement: i,
        overflows: H
      }], !H.every((L) => L <= 0)) {
        var F, N;
        const L = (((F = r.flip) == null ? void 0 : F.index) || 0) + 1, T = O[L];
        if (T) {
          var C;
          const b = u === "alignment" ? v !== X(T) : !1, E = ((C = S[0]) == null ? void 0 : C.overflows[0]) > 0;
          if (!b || E)
            return {
              data: {
                index: L,
                overflows: S
              },
              reset: {
                placement: T
              }
            };
        }
        let M = (N = S.filter((b) => b.overflows[0] <= 0).sort((b, E) => b.overflows[1] - E.overflows[1])[0]) == null ? void 0 : N.placement;
        if (!M)
          switch (d) {
            case "bestFit": {
              var k;
              const b = (k = S.filter((E) => {
                if (P) {
                  const $ = X(E.placement);
                  return $ === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  $ === "y";
                }
                return !0;
              }).map((E) => [E.placement, E.overflows.filter(($) => $ > 0).reduce(($, st) => $ + st, 0)]).sort((E, $) => E[1] - $[1])[0]) == null ? void 0 : k[0];
              b && (M = b);
              break;
            }
            case "initialPlacement":
              M = c;
              break;
          }
        if (i !== M)
          return {
            reset: {
              placement: M
            }
          };
      }
      return {};
    }
  };
};
function Ft(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Nt(t) {
  return Oe.some((e) => t[e] >= 0);
}
const Fe = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: o = "referenceHidden",
        ...i
      } = q(t, e);
      switch (o) {
        case "referenceHidden": {
          const r = await ot(e, {
            ...i,
            elementContext: "reference"
          }), s = Ft(r, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Nt(s)
            }
          };
        }
        case "escaped": {
          const r = await ot(e, {
            ...i,
            altBoundary: !0
          }), s = Ft(r, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Nt(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Ne(t, e) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = t, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), s = U(n), c = tt(n), l = X(n) === "y", a = ["left", "top"].includes(s) ? -1 : 1, f = r && l ? -1 : 1, u = q(e, t);
  let {
    mainAxis: p,
    crossAxis: d,
    alignmentAxis: m
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return c && typeof m == "number" && (d = c === "end" ? m * -1 : m), l ? {
    x: d * f,
    y: p * a
  } : {
    x: p * a,
    y: d * f
  };
}
const He = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: i,
        y: r,
        placement: s,
        middlewareData: c
      } = e, l = await Ne(e, t);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (o = c.arrow) != null && o.alignmentOffset ? {} : {
        x: i + l.x,
        y: r + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, We = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: i
      } = e, {
        mainAxis: r = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (w) => {
            let {
              x: g,
              y: v
            } = w;
            return {
              x: g,
              y: v
            };
          }
        },
        ...l
      } = q(t, e), a = {
        x: n,
        y: o
      }, f = await ot(e, l), u = X(U(i)), p = Rt(u);
      let d = a[p], m = a[u];
      if (r) {
        const w = p === "y" ? "top" : "left", g = p === "y" ? "bottom" : "right", v = d + f[w], A = d - f[g];
        d = yt(v, d, A);
      }
      if (s) {
        const w = u === "y" ? "top" : "left", g = u === "y" ? "bottom" : "right", v = m + f[w], A = m - f[g];
        m = yt(v, m, A);
      }
      const h = c.fn({
        ...e,
        [p]: d,
        [u]: m
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - o,
          enabled: {
            [p]: r,
            [u]: s
          }
        }
      };
    }
  };
}, _e = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: o,
        placement: i,
        rects: r,
        middlewareData: s
      } = e, {
        offset: c = 0,
        mainAxis: l = !0,
        crossAxis: a = !0
      } = q(t, e), f = {
        x: n,
        y: o
      }, u = X(i), p = Rt(u);
      let d = f[p], m = f[u];
      const h = q(c, e), w = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (l) {
        const A = p === "y" ? "height" : "width", x = r.reference[p] - r.floating[A] + w.mainAxis, y = r.reference[p] + r.reference[A] - w.mainAxis;
        d < x ? d = x : d > y && (d = y);
      }
      if (a) {
        var g, v;
        const A = p === "y" ? "width" : "height", x = ["top", "left"].includes(U(i)), y = r.reference[u] - r.floating[A] + (x && ((g = s.offset) == null ? void 0 : g[u]) || 0) + (x ? 0 : w.crossAxis), P = r.reference[u] + r.reference[A] + (x ? 0 : ((v = s.offset) == null ? void 0 : v[u]) || 0) - (x ? w.crossAxis : 0);
        m < y ? m = y : m > P && (m = P);
      }
      return {
        [p]: d,
        [u]: m
      };
    }
  };
}, Be = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: i,
        rects: r,
        platform: s,
        elements: c
      } = e, {
        apply: l = () => {
        },
        ...a
      } = q(t, e), f = await ot(e, a), u = U(i), p = tt(i), d = X(i) === "y", {
        width: m,
        height: h
      } = r.floating;
      let w, g;
      u === "top" || u === "bottom" ? (w = u, g = p === (await (s.isRTL == null ? void 0 : s.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (g = u, w = p === "end" ? "top" : "bottom");
      const v = h - f.top - f.bottom, A = m - f.left - f.right, x = Z(h - f[w], v), y = Z(m - f[g], A), P = !e.middlewareData.shift;
      let O = x, D = y;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (D = A), (o = e.middlewareData.shift) != null && o.enabled.y && (O = v), P && !p) {
        const S = W(f.left, 0), F = W(f.right, 0), N = W(f.top, 0), C = W(f.bottom, 0);
        d ? D = m - 2 * (S !== 0 || F !== 0 ? S + F : W(f.left, f.right)) : O = h - 2 * (N !== 0 || C !== 0 ? N + C : W(f.top, f.bottom));
      }
      await l({
        ...e,
        availableWidth: D,
        availableHeight: O
      });
      const H = await s.getDimensions(c.floating);
      return m !== H.width || h !== H.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function pt() {
  return typeof window < "u";
}
function et(t) {
  return Yt(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function _(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Y(t) {
  var e;
  return (e = (Yt(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Yt(t) {
  return pt() ? t instanceof Node || t instanceof _(t).Node : !1;
}
function B(t) {
  return pt() ? t instanceof Element || t instanceof _(t).Element : !1;
}
function I(t) {
  return pt() ? t instanceof HTMLElement || t instanceof _(t).HTMLElement : !1;
}
function Ht(t) {
  return !pt() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof _(t).ShadowRoot;
}
function rt(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: i
  } = z(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !["inline", "contents"].includes(i);
}
function ze(t) {
  return ["table", "td", "th"].includes(et(t));
}
function ht(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function Ct(t) {
  const e = St(), n = B(t) ? z(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function Ve(t) {
  let e = K(t);
  for (; I(e) && !Q(e); ) {
    if (Ct(e))
      return e;
    if (ht(e))
      return null;
    e = K(e);
  }
  return null;
}
function St() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Q(t) {
  return ["html", "body", "#document"].includes(et(t));
}
function z(t) {
  return _(t).getComputedStyle(t);
}
function gt(t) {
  return B(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function K(t) {
  if (et(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Ht(t) && t.host || // Fallback.
    Y(t)
  );
  return Ht(e) ? e.host : e;
}
function jt(t) {
  const e = K(t);
  return Q(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : I(e) && rt(e) ? e : jt(e);
}
function it(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = jt(t), r = i === ((o = t.ownerDocument) == null ? void 0 : o.body), s = _(i);
  if (r) {
    const c = At(s);
    return e.concat(s, s.visualViewport || [], rt(i) ? i : [], c && n ? it(c) : []);
  }
  return e.concat(i, it(i, [], n));
}
function At(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function Xt(t) {
  const e = z(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const i = I(t), r = i ? t.offsetWidth : n, s = i ? t.offsetHeight : o, c = ft(n) !== r || ft(o) !== s;
  return c && (n = r, o = s), {
    width: n,
    height: o,
    $: c
  };
}
function Et(t) {
  return B(t) ? t : t.contextElement;
}
function J(t) {
  const e = Et(t);
  if (!I(e))
    return V(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: i,
    $: r
  } = Xt(e);
  let s = (r ? ft(n.width) : n.width) / o, c = (r ? ft(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const Ie = /* @__PURE__ */ V(0);
function qt(t) {
  const e = _(t);
  return !St() || !e.visualViewport ? Ie : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Ye(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== _(t) ? !1 : e;
}
function G(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), r = Et(t);
  let s = V(1);
  e && (o ? B(o) && (s = J(o)) : s = J(t));
  const c = Ye(r, n, o) ? qt(r) : V(0);
  let l = (i.left + c.x) / s.x, a = (i.top + c.y) / s.y, f = i.width / s.x, u = i.height / s.y;
  if (r) {
    const p = _(r), d = o && B(o) ? _(o) : o;
    let m = p, h = At(m);
    for (; h && o && d !== m; ) {
      const w = J(h), g = h.getBoundingClientRect(), v = z(h), A = g.left + (h.clientLeft + parseFloat(v.paddingLeft)) * w.x, x = g.top + (h.clientTop + parseFloat(v.paddingTop)) * w.y;
      l *= w.x, a *= w.y, f *= w.x, u *= w.y, l += A, a += x, m = _(h), h = At(m);
    }
  }
  return dt({
    width: f,
    height: u,
    x: l,
    y: a
  });
}
function Dt(t, e) {
  const n = gt(t).scrollLeft;
  return e ? e.left + n : G(Y(t)).left + n;
}
function Ut(t, e, n) {
  n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), i = o.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Dt(t, o)
  )), r = o.top + e.scrollTop;
  return {
    x: i,
    y: r
  };
}
function je(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: i
  } = t;
  const r = i === "fixed", s = Y(o), c = e ? ht(e.floating) : !1;
  if (o === s || c && r)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = V(1);
  const f = V(0), u = I(o);
  if ((u || !u && !r) && ((et(o) !== "body" || rt(s)) && (l = gt(o)), I(o))) {
    const d = G(o);
    a = J(o), f.x = d.x + o.clientLeft, f.y = d.y + o.clientTop;
  }
  const p = s && !u && !r ? Ut(s, l, !0) : V(0);
  return {
    width: n.width * a.x,
    height: n.height * a.y,
    x: n.x * a.x - l.scrollLeft * a.x + f.x + p.x,
    y: n.y * a.y - l.scrollTop * a.y + f.y + p.y
  };
}
function Xe(t) {
  return Array.from(t.getClientRects());
}
function qe(t) {
  const e = Y(t), n = gt(t), o = t.ownerDocument.body, i = W(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), r = W(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + Dt(t);
  const c = -n.scrollTop;
  return z(o).direction === "rtl" && (s += W(e.clientWidth, o.clientWidth) - i), {
    width: i,
    height: r,
    x: s,
    y: c
  };
}
function Ue(t, e) {
  const n = _(t), o = Y(t), i = n.visualViewport;
  let r = o.clientWidth, s = o.clientHeight, c = 0, l = 0;
  if (i) {
    r = i.width, s = i.height;
    const a = St();
    (!a || a && e === "fixed") && (c = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: c,
    y: l
  };
}
function Ze(t, e) {
  const n = G(t, !0, e === "fixed"), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = I(t) ? J(t) : V(1), s = t.clientWidth * r.x, c = t.clientHeight * r.y, l = i * r.x, a = o * r.y;
  return {
    width: s,
    height: c,
    x: l,
    y: a
  };
}
function Wt(t, e, n) {
  let o;
  if (e === "viewport")
    o = Ue(t, n);
  else if (e === "document")
    o = qe(Y(t));
  else if (B(e))
    o = Ze(e, n);
  else {
    const i = qt(t);
    o = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return dt(o);
}
function Zt(t, e) {
  const n = K(t);
  return n === e || !B(n) || Q(n) ? !1 : z(n).position === "fixed" || Zt(n, e);
}
function Ke(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = it(t, [], !1).filter((c) => B(c) && et(c) !== "body"), i = null;
  const r = z(t).position === "fixed";
  let s = r ? K(t) : t;
  for (; B(s) && !Q(s); ) {
    const c = z(s), l = Ct(s);
    !l && c.position === "fixed" && (i = null), (r ? !l && !i : !l && c.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || rt(s) && !l && Zt(t, s)) ? o = o.filter((f) => f !== s) : i = c, s = K(s);
  }
  return e.set(t, o), o;
}
function Ge(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = t;
  const s = [...n === "clippingAncestors" ? ht(e) ? [] : Ke(e, this._c) : [].concat(n), o], c = s[0], l = s.reduce((a, f) => {
    const u = Wt(e, f, i);
    return a.top = W(u.top, a.top), a.right = Z(u.right, a.right), a.bottom = Z(u.bottom, a.bottom), a.left = W(u.left, a.left), a;
  }, Wt(e, c, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Je(t) {
  const {
    width: e,
    height: n
  } = Xt(t);
  return {
    width: e,
    height: n
  };
}
function Qe(t, e, n) {
  const o = I(e), i = Y(e), r = n === "fixed", s = G(t, !0, r, e);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = V(0);
  function a() {
    l.x = Dt(i);
  }
  if (o || !o && !r)
    if ((et(e) !== "body" || rt(i)) && (c = gt(e)), o) {
      const d = G(e, !0, r, e);
      l.x = d.x + e.clientLeft, l.y = d.y + e.clientTop;
    } else i && a();
  r && !o && i && a();
  const f = i && !o && !r ? Ut(i, c) : V(0), u = s.left + c.scrollLeft - l.x - f.x, p = s.top + c.scrollTop - l.y - f.y;
  return {
    x: u,
    y: p,
    width: s.width,
    height: s.height
  };
}
function wt(t) {
  return z(t).position === "static";
}
function _t(t, e) {
  if (!I(t) || z(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return Y(t) === n && (n = n.ownerDocument.body), n;
}
function Kt(t, e) {
  const n = _(t);
  if (ht(t))
    return n;
  if (!I(t)) {
    let i = K(t);
    for (; i && !Q(i); ) {
      if (B(i) && !wt(i))
        return i;
      i = K(i);
    }
    return n;
  }
  let o = _t(t, e);
  for (; o && ze(o) && wt(o); )
    o = _t(o, e);
  return o && Q(o) && wt(o) && !Ct(o) ? n : o || Ve(t) || n;
}
const tn = async function(t) {
  const e = this.getOffsetParent || Kt, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: Qe(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function en(t) {
  return z(t).direction === "rtl";
}
const nn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: je,
  getDocumentElement: Y,
  getClippingRect: Ge,
  getOffsetParent: Kt,
  getElementRects: tn,
  getClientRects: Xe,
  getDimensions: Je,
  getScale: J,
  isElement: B,
  isRTL: en
};
function Gt(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function on(t, e) {
  let n = null, o;
  const i = Y(t);
  function r() {
    var c;
    clearTimeout(o), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, l) {
    c === void 0 && (c = !1), l === void 0 && (l = 1), r();
    const a = t.getBoundingClientRect(), {
      left: f,
      top: u,
      width: p,
      height: d
    } = a;
    if (c || e(), !p || !d)
      return;
    const m = lt(u), h = lt(i.clientWidth - (f + p)), w = lt(i.clientHeight - (u + d)), g = lt(f), A = {
      rootMargin: -m + "px " + -h + "px " + -w + "px " + -g + "px",
      threshold: W(0, Z(1, l)) || 1
    };
    let x = !0;
    function y(P) {
      const O = P[0].intersectionRatio;
      if (O !== l) {
        if (!x)
          return s();
        O ? s(!1, O) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      O === 1 && !Gt(a, t.getBoundingClientRect()) && s(), x = !1;
    }
    try {
      n = new IntersectionObserver(y, {
        ...A,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(y, A);
    }
    n.observe(t);
  }
  return s(!0), r;
}
function rn(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, a = Et(t), f = i || r ? [...a ? it(a) : [], ...it(e)] : [];
  f.forEach((g) => {
    i && g.addEventListener("scroll", n, {
      passive: !0
    }), r && g.addEventListener("resize", n);
  });
  const u = a && c ? on(a, n) : null;
  let p = -1, d = null;
  s && (d = new ResizeObserver((g) => {
    let [v] = g;
    v && v.target === a && d && (d.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var A;
      (A = d) == null || A.observe(e);
    })), n();
  }), a && !l && d.observe(a), d.observe(e));
  let m, h = l ? G(t) : null;
  l && w();
  function w() {
    const g = G(t);
    h && !Gt(h, g) && n(), h = g, m = requestAnimationFrame(w);
  }
  return n(), () => {
    var g;
    f.forEach((v) => {
      i && v.removeEventListener("scroll", n), r && v.removeEventListener("resize", n);
    }), u?.(), (g = d) == null || g.disconnect(), d = null, l && cancelAnimationFrame(m);
  };
}
const sn = He, cn = We, ln = ke, an = Be, fn = Fe, Bt = $e, un = _e, dn = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: nn,
    ...n
  }, r = {
    ...i.platform,
    _c: o
  };
  return Me(t, e, {
    ...i,
    platform: r
  });
};
var at = typeof document < "u" ? xe : ye;
function mt(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, i;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!mt(t[o], e[o]))
          return !1;
      return !0;
    }
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, i[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const r = i[o];
      if (!(r === "_owner" && t.$$typeof) && !mt(t[r], e[r]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Jt(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function zt(t, e) {
  const n = Jt(t);
  return Math.round(e * n) / n;
}
function xt(t) {
  const e = R.useRef(t);
  return at(() => {
    e.current = t;
  }), e;
}
function mn(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: i,
    elements: {
      reference: r,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: l,
    open: a
  } = t, [f, u] = R.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [p, d] = R.useState(o);
  mt(p, o) || d(o);
  const [m, h] = R.useState(null), [w, g] = R.useState(null), v = R.useCallback((b) => {
    b !== P.current && (P.current = b, h(b));
  }, []), A = R.useCallback((b) => {
    b !== O.current && (O.current = b, g(b));
  }, []), x = r || m, y = s || w, P = R.useRef(null), O = R.useRef(null), D = R.useRef(f), H = l != null, S = xt(l), F = xt(i), N = xt(a), C = R.useCallback(() => {
    if (!P.current || !O.current)
      return;
    const b = {
      placement: e,
      strategy: n,
      middleware: p
    };
    F.current && (b.platform = F.current), dn(P.current, O.current, b).then((E) => {
      const $ = {
        ...E,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: N.current !== !1
      };
      k.current && !mt(D.current, $) && (D.current = $, ve.flushSync(() => {
        u($);
      }));
    });
  }, [p, e, n, F, N]);
  at(() => {
    a === !1 && D.current.isPositioned && (D.current.isPositioned = !1, u((b) => ({
      ...b,
      isPositioned: !1
    })));
  }, [a]);
  const k = R.useRef(!1);
  at(() => (k.current = !0, () => {
    k.current = !1;
  }), []), at(() => {
    if (x && (P.current = x), y && (O.current = y), x && y) {
      if (S.current)
        return S.current(x, y, C);
      C();
    }
  }, [x, y, C, S, H]);
  const L = R.useMemo(() => ({
    reference: P,
    floating: O,
    setReference: v,
    setFloating: A
  }), [v, A]), T = R.useMemo(() => ({
    reference: x,
    floating: y
  }), [x, y]), M = R.useMemo(() => {
    const b = {
      position: n,
      left: 0,
      top: 0
    };
    if (!T.floating)
      return b;
    const E = zt(T.floating, f.x), $ = zt(T.floating, f.y);
    return c ? {
      ...b,
      transform: "translate(" + E + "px, " + $ + "px)",
      ...Jt(T.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: E,
      top: $
    };
  }, [n, c, T.floating, f.x, f.y]);
  return R.useMemo(() => ({
    ...f,
    update: C,
    refs: L,
    elements: T,
    floatingStyles: M
  }), [f, C, L, T, M]);
}
const pn = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: o,
        padding: i
      } = typeof t == "function" ? t(n) : t;
      return o && e(o) ? o.current != null ? Bt({
        element: o.current,
        padding: i
      }).fn(n) : {} : o ? Bt({
        element: o,
        padding: i
      }).fn(n) : {};
    }
  };
}, hn = (t, e) => ({
  ...sn(t),
  options: [t, e]
}), gn = (t, e) => ({
  ...cn(t),
  options: [t, e]
}), wn = (t, e) => ({
  ...un(t),
  options: [t, e]
}), xn = (t, e) => ({
  ...ln(t),
  options: [t, e]
}), yn = (t, e) => ({
  ...an(t),
  options: [t, e]
}), vn = (t, e) => ({
  ...fn(t),
  options: [t, e]
}), An = (t, e) => ({
  ...pn(t),
  options: [t, e]
});
var bn = "Arrow", Qt = R.forwardRef((t, e) => {
  const { children: n, width: o = 10, height: i = 5, ...r } = t;
  return /* @__PURE__ */ j(
    bt.svg,
    {
      ...r,
      ref: e,
      width: o,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? n : /* @__PURE__ */ j("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Qt.displayName = bn;
var Rn = Qt, Lt = "Popper", [te, Nn] = Ae(Lt), [On, ee] = te(Lt), ne = (t) => {
  const { __scopePopper: e, children: n } = t, [o, i] = R.useState(null);
  return /* @__PURE__ */ j(On, { scope: e, anchor: o, onAnchorChange: i, children: n });
};
ne.displayName = Lt;
var oe = "PopperAnchor", ie = R.forwardRef(
  (t, e) => {
    const { __scopePopper: n, virtualRef: o, ...i } = t, r = ee(oe, n), s = R.useRef(null), c = Vt(e, s), l = R.useRef(null);
    return R.useEffect(() => {
      const a = l.current;
      l.current = o?.current || s.current, a !== l.current && r.onAnchorChange(l.current);
    }), o ? null : /* @__PURE__ */ j(bt.div, { ...i, ref: c });
  }
);
ie.displayName = oe;
var Tt = "PopperContent", [Pn, Cn] = te(Tt), re = R.forwardRef(
  (t, e) => {
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: i = 0,
      align: r = "center",
      alignOffset: s = 0,
      arrowPadding: c = 0,
      avoidCollisions: l = !0,
      collisionBoundary: a = [],
      collisionPadding: f = 0,
      sticky: u = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: d = "optimized",
      onPlaced: m,
      ...h
    } = t, w = ee(Tt, n), [g, v] = R.useState(null), A = Vt(e, (nt) => v(nt)), [x, y] = R.useState(null), P = Re(x), O = P?.width ?? 0, D = P?.height ?? 0, H = o + (r !== "center" ? "-" + r : ""), S = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, F = Array.isArray(a) ? a : [a], N = F.length > 0, C = {
      padding: S,
      boundary: F.filter(En),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: N
    }, { refs: k, floatingStyles: L, placement: T, isPositioned: M, middlewareData: b } = mn({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: H,
      whileElementsMounted: (...nt) => rn(...nt, {
        animationFrame: d === "always"
      }),
      elements: {
        reference: w.anchor
      },
      middleware: [
        hn({ mainAxis: i + D, alignmentAxis: s }),
        l && gn({
          mainAxis: !0,
          crossAxis: !1,
          limiter: u === "partial" ? wn() : void 0,
          ...C
        }),
        l && xn({ ...C }),
        yn({
          ...C,
          apply: ({ elements: nt, rects: Mt, availableWidth: pe, availableHeight: he }) => {
            const { width: ge, height: we } = Mt.reference, ct = nt.floating.style;
            ct.setProperty("--radix-popper-available-width", `${pe}px`), ct.setProperty("--radix-popper-available-height", `${he}px`), ct.setProperty("--radix-popper-anchor-width", `${ge}px`), ct.setProperty("--radix-popper-anchor-height", `${we}px`);
          }
        }),
        x && An({ element: x, padding: c }),
        Dn({ arrowWidth: O, arrowHeight: D }),
        p && vn({ strategy: "referenceHidden", ...C })
      ]
    }), [E, $] = le(T), st = be(m);
    $t(() => {
      M && st?.();
    }, [M, st]);
    const ae = b.arrow?.x, fe = b.arrow?.y, ue = b.arrow?.centerOffset !== 0, [de, me] = R.useState();
    return $t(() => {
      g && me(window.getComputedStyle(g).zIndex);
    }, [g]), /* @__PURE__ */ j(
      "div",
      {
        ref: k.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...L,
          transform: M ? L.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: de,
          "--radix-popper-transform-origin": [
            b.transformOrigin?.x,
            b.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...b.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ j(
          Pn,
          {
            scope: n,
            placedSide: E,
            onArrowChange: y,
            arrowX: ae,
            arrowY: fe,
            shouldHideArrow: ue,
            children: /* @__PURE__ */ j(
              bt.div,
              {
                "data-side": E,
                "data-align": $,
                ...h,
                ref: A,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: M ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
re.displayName = Tt;
var se = "PopperArrow", Sn = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, ce = R.forwardRef(function(e, n) {
  const { __scopePopper: o, ...i } = e, r = Cn(se, o), s = Sn[r.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ j(
      "span",
      {
        ref: r.onArrowChange,
        style: {
          position: "absolute",
          left: r.arrowX,
          top: r.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[r.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[r.placedSide],
          visibility: r.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ j(
          Rn,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
ce.displayName = se;
function En(t) {
  return t !== null;
}
var Dn = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    const { placement: n, rects: o, middlewareData: i } = e, s = i.arrow?.centerOffset !== 0, c = s ? 0 : t.arrowWidth, l = s ? 0 : t.arrowHeight, [a, f] = le(n), u = { start: "0%", center: "50%", end: "100%" }[f], p = (i.arrow?.x ?? 0) + c / 2, d = (i.arrow?.y ?? 0) + l / 2;
    let m = "", h = "";
    return a === "bottom" ? (m = s ? u : `${p}px`, h = `${-l}px`) : a === "top" ? (m = s ? u : `${p}px`, h = `${o.floating.height + l}px`) : a === "right" ? (m = `${-l}px`, h = s ? u : `${d}px`) : a === "left" && (m = `${o.floating.width + l}px`, h = s ? u : `${d}px`), { data: { x: m, y: h } };
  }
});
function le(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
var Hn = ne, Wn = ie, _n = re, Bn = ce;
export {
  Wn as A,
  _n as C,
  Hn as R,
  Bn as a,
  Nn as c
};
